export const socialsData = {
    github: 'https://github.com/algorithmicprogrammer',
    linkedIn: 'https://www.linkedin.com/in/algorithmicprogrammer',
    stackOverflow: 'https://stackoverflow.com/users/4105019/algorithmic-programmer',
    treehouse:"https://www.teamtreehouse.com/algorithmicprogrammer",
    codecademy:"https://www.codecademy.com/profiles/algorithmicprogrammer",
    hackerrank:"https://www.hackerrank.com/profile/algorithmicprog"
}